<template>
    <v-container fill-height>
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card class="white--text px-5" title="Categories"
                               text="">

                    <div class="text-right">
                        <v-btn
                                color="blue-grey darken-4"
                                @click="new_category(null)"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </div>

                    <template>
                        <table class="table">
                            <tr>
                                <th class="text-xs-left">Name</th>
                                <th class="text-xs-left">Sub Categories</th>
                            </tr>
                            <tr v-for="category in categories">
                                <td style="vertical-align: top;">
                               <span @click="edit_category(category)">
                                   {{ category.name }}
                               </span>

                                    <v-btn rounded small fab text
                                           color="success"
                                           @click="new_category(category.id)">
                                        <v-icon>
                                            mdi-plus
                                        </v-icon>
                                    </v-btn>

                                </td>
                                <td style="vertical-align: top;">
                                    <ul class="first_child">
                                        <li v-for="first_child in category.children">

                                       <span @click="edit_category(first_child)">
                                           {{ first_child.name }}
                                       </span>

                                            <v-btn rounded text small fab
                                                   color="success"
                                                   @click="new_category(first_child.id)">
                                                <v-icon>
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>

                                            <ul class="second_child">
                                                <li v-for="second_child in first_child.children">
                                                <span @click="edit_category(second_child)">
                                                    {{ second_child.name }}
                                                </span>

                                                    <v-btn rounded text small fab
                                                           color="success"
                                                           @click="new_category(second_child.id)">
                                                        <v-icon>
                                                            mdi-plus
                                                        </v-icon>
                                                    </v-btn>

                                                    <ul class="third_child">
                                                        <li v-for="third_child in second_child.children">
                                                        <span @click="edit_category(third_child)">
                                                            {{ third_child.name }}
                                                        </span>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </table>
                    </template>

                </material-card>
            </v-flex>

            <v-flex md12>
                <v-dialog v-if="!!category_dialog"
                          fullscreen
                          v-model="category_dialog">

                    <v-card>
                        <v-toolbar color="primary"
                        >
                            <v-btn icon dark @click="category_dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title class="white--text">
                                {{ category.name }}
                            </v-toolbar-title>
                            <div class="flex-grow-1"></div>
                            <v-toolbar-items>

                                <v-btn dark text @click="save_category(category)">Save Category</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-card-text>


                            <v-form
                                    ref="form"
                                    onSubmit="return false;">

                                <v-text-field
                                        v-model="category.name"
                                        label="Name"
                                        required=""></v-text-field>


                                <input v-model="category.id" type="hidden">
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-btn
                                style="margin-top:15px; margin-bottom:15px;"
                                block
                              color="blue-grey darken-4"

                              @click="copy_products_from_single(category)"
                            >
                              Copy Products From Other Sub Category
                            </v-btn>
                        <v-divider></v-divider>
                        <v-simple-table dense v-show="category.id">
                            <thead>
                            <tr>
                                <th class="text-left">
                                    Products
                                    <v-btn
                                            color="blue-grey darken-4"
                                            @click="edit_product({})"
                                            fab
                                            small
                                            text
                                            text
                                    >
                                        <v-icon>
                                            mdi-plus
                                        </v-icon>
                                    </v-btn>
                                </th>
                                <th class="text-left">Sizes</th>
                                <th class="text-left">Mixes</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="product in category.products" :key="product.id">
                                <td @click="edit_product(product)">{{ product.name }}</td>
                                <td>
                                    <table>
                                        <tr>
                                            <th>Name
                                                <v-btn
                                                        color="blue-grey darken-4"
                                                        small
                                                        fab
                                                        text
                                                        rounded
                                                        @click="edit_attr({attribute:1}, product)"
                                                >
                                                    <v-icon>
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </th>
                                            <th>Price</th>
                                        </tr>
                                        <tr v-for="size in product.sizes">
                                            <td>
                                                <span @click="edit_attr(size, product)">
                                                    {{ size.name }}
                                                </span>
                                            </td>
                                            <td>
                                                {{ size.price }}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td>

                                    <table>
                                        <tr>
                                            <th>Name
                                                <v-btn
                                                        color="blue-grey darken-4"
                                                        small
                                                        fab
                                                        rounded
                                                        text
                                                        @click="edit_attr({attribute:2}, product)"
                                                >
                                                    <v-icon>
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </th>
                                            <th>Price</th>
                                        </tr>
                                        <tr v-for="mix in product.mixes">
                                            <td>
                                                <span @click="edit_attr(mix, product)">
                                                    {{ mix.name }}
                                                </span>
                                            </td>
                                            <td>
                                                {{ mix.price }}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                        <v-divider></v-divider>

                        <v-dialog v-model="product_dialog">
                            <v-card>
                                <v-card-text>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="product.name"
                                                :counter="500"
                                                label="Name"
                                                required
                                                :error-messages="checkName"
                                                @input="$v.product.name.$touch()"
                                                @blur="$v.product.name.$touch()"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="product.price"
                                                label="Price"
                                                required
                                                :error-messages="checkPrice"
                                                @input="$v.product.price.$touch()"
                                                @blur="$v.product.price.$touch()"

                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                                v-model="product.happy_hour_type"
                                                :items="happy_hour_opts"
                                                item-value="id"
                                                item-text="name"
                                                required
                                                :error-messages="checkHappyHourType"
                                                @input="$v.product.happy_hour_type.$touch()"
                                                @blur="$v.product.happy_hour_type.$touch()"
                                                label="Happy Hour Type"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="product.happy_hour_amount"
                                                label="Happy Hour Amount"
                                                required
                                                :error-messages="checkHappyHourAmount"
                                                @input="$v.product.happy_hour_amount.$touch()"
                                                @blur="$v.product.happy_hour_amount.$touch()"

                                        ></v-text-field>
                                    </v-flex>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           v-show="product.id"
                                           text @click="delete_product(product)">Delete
                                    </v-btn>

                                    <v-btn color="blue darken-1" text @click="product_dialog=false">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="save_product(product)">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="attr_dialog">
                            <v-card>
                                <v-card-text>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="attr.name"
                                                :counter="500"
                                                label="Name"
                                                required
                                                :error-messages="checkAttrName"
                                                @input="$v.attr.name.$touch()"
                                                @blur="$v.attr.name.$touch()"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="attr.price"
                                                label="Price"
                                                required
                                                :error-messages="checkAttrPrice"
                                                @input="$v.attr.price.$touch()"
                                                @blur="$v.attr.price.$touch()"

                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                                v-model="attr.happy_hour_type"
                                                :items="happy_hour_opts"
                                                item-value="id"
                                                item-text="name"
                                                required
                                                :error-messages="checkAttrHappyHourType"
                                                @input="$v.attr.happy_hour_type.$touch()"
                                                @blur="$v.attr.happy_hour_type.$touch()"
                                                label="Happy Hour Type"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="attr.happy_hour_amount"
                                                label="Happy Hour Amount"
                                                required
                                                :error-messages="checkAttrHappyHourAmount"
                                                @input="$v.attr.happy_hour_amount.$touch()"
                                                @blur="$v.attr.happy_hour_amount.$touch()"

                                        ></v-text-field>
                                    </v-flex>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text
                                           v-show="attr.id"
                                           @click="delete_attr(attr)">Delete
                                    </v-btn>
                                    <v-btn color="blue darken-1" text @click="attr_dialog=false">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="save_attribute_value(attr, product)">
                                        Save
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    v-show="category.id"
                                    color="blue-grey darken-4"
                                    @click="delete_category(category)"
                            >
                                <v-icon>
                                    mdi-delete
                                </v-icon>
                                Delete Category
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>


            </v-flex>
        </v-layout>
    </v-container>
</template>
<style lang="scss">

</style>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email, decimal, numeric} from 'vuelidate/lib/validators'

    export default {
        components: {},
        mixins: [validationMixin],
        validations: {
            product: {
                name: {
                    required,
                    maxLength: maxLength(500),
                    minLength: minLength(1)
                },
                price: {
                    required,
                    decimal,
                },
                happy_hour_type: {
                    required
                },
                happy_hour_amount: {
                    required,
                    numeric
                }
            },
            attr: {
                name: {
                    required,
                    maxLength: maxLength(500),
                    minLength: minLength(1)
                },
                price: {
                    required,
                    decimal,
                },
                happy_hour_type: {
                    required
                },
                happy_hour_amount: {
                    required,
                    numeric
                }
            },

        },

        data() {
            return {
                categories: [],
                category_dialog: false,
                category: {
                    id: 0,
                    name: ''
                },
                notification: false,
                notification_message: '',
                notification_type: '',
                new_product: false,
                product: {},
                attr: {},
                product_dialog: false,
                attr_dialog: false,
                happy_hour_opts: [
                    {
                        id: 1,
                        name: 'Different Price During HH'
                    },
                    {
                        id: 2,
                        name: 'Buy One Get One'
                    },
                    {
                        id: 3,
                        name: 'None'
                    }
                ],
            }
        },
        computed: {
            checkName() {
                const errors = [];
                if (!this.$v.product.name.$dirty) return errors;
                !this.$v.product.name.maxLength && errors.push('name must be at most 500 characters long');
                !this.$v.product.name.minLength && errors.push('name must be at least 1 characters long');
                !this.$v.product.name.required && errors.push('name is required.');
                return errors;
            },
            checkPrice() {
                const errors = [];
                if (!this.$v.product.price.$dirty) return errors;
                !this.$v.product.price.decimal && errors.push('.price must be a valid decimal exmp: 0.00');
                !this.$v.product.price.required && errors.push('.price is required.');
                return errors;
            },
            checkHappyHourType() {
                const errors = [];
                if (!this.$v.product.happy_hour_type.$dirty) return errors;
                !this.$v.product.happy_hour_type.required && errors.push('product.happy_hour_type is required.');
                return errors;
            },
            checkHappyHourAmount() {
                const errors = [];
                if (!this.$v.product.happy_hour_amount.$dirty) return errors;
                !this.$v.product.happy_hour_amount.numeric && errors.push('.happy_hour_amount must be a number value');
                !this.$v.product.happy_hour_amount.required && errors.push('.happy_hour_amount is required. If promo is Buy One Get one put 0');
                return errors;
            },
            // SIZES
            checkAttrName() {
                const errors = [];
                if (!this.$v.attr.name.$dirty) return errors;
                !this.$v.attr.name.maxLength && errors.push('name must be at most 500 characters long');
                !this.$v.attr.name.minLength && errors.push('name must be at least 1 characters long');
                !this.$v.attr.name.required && errors.push('name is required.');
                return errors;
            },
            checkAttrPrice() {
                const errors = [];
                if (!this.$v.attr.price.$dirty) return errors;
                !this.$v.attr.price.decimal && errors.push('.price must be a valid decimal exmp: 0.00');
                !this.$v.attr.price.required && errors.push('.price is required.');
                return errors;
            },
            checkAttrHappyHourType() {
                const errors = [];
                if (!this.$v.attr.happy_hour_type.$dirty) return errors;
                !this.$v.attr.happy_hour_type.required && errors.push('attr.happy_hour_type is required.');
                return errors;
            },
            checkAttrHappyHourAmount() {
                const errors = [];
                if (!this.$v.attr.happy_hour_amount.$dirty) return errors;
                !this.$v.attr.happy_hour_amount.numeric && errors.push('.happy_hour_amount must be a number value');
                !this.$v.attr.happy_hour_amount.required && errors.push('.happy_hour_amount is required. If promo is Buy One Get one put 0');
                return errors;
            },
        },

        created() {
            this.load_categories();
        },
        methods: {
            delete_attr(attr) {
                if (confirm('Are yous ure you want to delete this attribute ?')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/attribute-values/' + attr.id + '/').then((response) => {
                        console.log(response);
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.attr_dialog = false;
                        this.category_dialog = false;
                        this.load_categories();
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },
            copy_products_from_single(category) {

                if(confirm('Are you sure you want to copy products from another other categories in the same sub tree ?'))
                {
                    console.log(category);
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/category-copy-single/',{
                            parent: category.parent_id,
                            category: category.id
                        }).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Copied';
                        this.load_categories();
                        this.category_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            delete_product(product) {
                if (confirm('Are yous ure you want to delete this product ? ')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/products/' + product.id + '/').then((response) => {
                        console.log(response);
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted Product';
                        this.load_categories();
                        this.product_dialog = false;
                        this.category_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            new_category(parent) {
                this.category = {
                    parent: parent,
                    name: '',
                    id: 0
                };
                this.category_dialog = true;
            },
            edit_product(product) {
                if (typeof product.id === 'undefined') {
                    this.product = {
                        id: 0,
                        name: '',
                        price: 0,
                        happy_hour_amount: 0,
                        happy_hour_type: 3,
                        category: this.category.id
                    }
                } else {
                    this.product = product;
                }
                this.product_dialog = true;
            },
            edit_attr(attr, product) {
                console.log(attr);
                if (typeof attr.id === 'undefined') {
                    this.attr = {
                        id: null,
                        name: '',
                        price: product.price,
                        happy_hour_amount: product.happy_hour_amount,
                        happy_hour_type: product.happy_hour_type,
                        product: product.id,
                        attribute: attr.attribute
                    }
                } else {
                    this.attr = attr;
                }
                this.product = product;
                this.attr_dialog = true;
            },
            save_product(product) {
                this.$v.product.$touch();

                if (this.$v.product.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }

                if (product.id > 0) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/products/' + product.id + '/', product).then((response) => {
                        this.notification = true;
                        this.notification_type = 'success';

                        this.notification_message = 'Successfully Saved';
                        this.product_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/products/', product).then((response) => {
                        this.notification = true;
                        this.notification_type = 'success';
                        this.notification_message = 'Successfully Saved';
                        console.log(response);
                        this.category.products.push(response.data);
                        this.product_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }


            },
            delete_category(category) {
                if (confirm("Are you sure you want to delete this category, all sub categories and products relating to " + category.name + " will also be deleted ?")) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/categories/' + category.id + '/').then((response) => {
                        console.log(response);
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted Category';
                        this.load_categories();
                        this.category_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },
            save_attribute_value(attr, product) {
                this.$v.attr.$touch();

                if (this.$v.attr.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }


                if (attr.id > 0) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/attribute-values/' + attr.id + '/', attr).then((response) => {
                        this.notification = true;
                        this.notification_type = 'success';

                        this.notification_message = 'Successfully Saved';
                        this.attr_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/attribute-values/', attr).then((response) => {
                        this.notification = true;
                        this.notification_type = 'success';
                        this.notification_message = 'Successfully Saved';
                        console.log(response);
                        if (attr.attribute === 2) {
                            if (typeof product.mixes === 'undefined') {
                                product.mixes = [];
                            }
                            product.mixes.push(response.data);
                        } else {
                            if (typeof product.sizes === 'undefined') {
                                product.sizes = [];
                            }
                            product.sizes.push(response.data);
                        }
                        this.attr_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },
            edit_category(cat) {
                /**
                 * Load Category data
                 */
                this.category = cat;
                this.category_dialog = true;
            },
            save_category(cat) {
                if (typeof cat.id !== 'undefined' && cat.id > 0) {
                    //put
                    if (cat.parent) {
                        cat.parent = cat.parent.id;
                    }

                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/categories/' + cat.id + '/', cat).then((response) => {
                        this.load_categories();
                        this.category_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                } else {
                    //post
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/categories/', cat).then((response) => {
                        console.log(response);
                        this.load_categories();
                        this.category_dialog = false;
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },
            load_categories() {
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/categories/').then((response) => {
                    this.categories = response.data;

                    console.log(response.data);
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            }
        }
    }
</script>
